var $ = Object.defineProperty;
var m = (e, t, r) => t in e ? $(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var y = (e, t, r) => (m(e, typeof t != "symbol" ? t + "" : t, r), r);
const l = (e) => e != null, b = (e) => typeof e == "object" && Object.keys(e).length > 0, j = (e) => Array.isArray(e) && e.length > 0, A = (e) => typeof e == "string" && e.length > 0, E = (e) => l(e) && (b(e) || j(e) || A(e)), c = (e) => decodeURI(e).trim(), h = (e) => {
  const t = l(e) ? Object.keys(e) : [], r = t.length - 1;
  return r < 0 ? "" : t.reduce((n, s, o) => `${n}${s}=${e[s]}${o < r ? "&" : ""}`, "?");
}, a = (e, t) => {
  const r = {};
  return e.forEach((n, s) => {
    r[`${t}${s + 1}`] = n;
  }), r;
}, p = (e) => {
  const t = [];
  if (!E(e))
    return t;
  if (typeof e == "string")
    t.push(e);
  else if (Array.isArray(e))
    t.push(...e);
  else {
    const [r] = Object.keys(e), [n] = Object.values(e);
    t.push(r), t.push(...p(n));
  }
  return t;
};
class P {
  constructor(t) {
    y(this, "_host");
    this._host = t;
  }
  sendPageView(t) {
    const { url: r = "", referrer: n = "", pageName: s, path: o = "hits/pageview/" } = t, i = `${this._host}${o}`, u = h({
      url: c(r),
      referrer: c(n),
      param2: s
    });
    navigator.sendBeacon(i + u);
  }
  sendEvent(t) {
    const {
      url: r = "",
      referrer: n = "",
      eventName: s,
      experiments: o = [],
      params: i,
      plainQueryParams: u = {},
      path: g = "hits/event/"
    } = t, f = `${this._host}${g}`, d = h({
      url: c(r),
      referrer: c(n),
      eventName: s,
      ...a(o, "exp"),
      ...a(p(i), "param"),
      ...u
    });
    navigator.sendBeacon(f + d);
  }
}
export {
  P as JtClickHouse
};
